export const SCIM_TOKEN_TTL_MS = 1000 * 60 * 60 * 24 * 365;

// Per-minute window sized for bulk IdP syncs (~50 req/s). The throttle is a
// DoS guard, not a quota; IdPs back off on the 429's Retry-After header.
export const SCIM_RATE_LIMIT_WINDOW_MS = 1000 * 60;
export const SCIM_RATE_LIMIT_MAX_REQUESTS = 3000;

// Single source of truth for invalidating a stored SCIM bearer token: every
// path that disables SCIM must null all of these so a leaked token can't be
// reactivated. Keep this exhaustive when adding new SCIM token columns.
export const CLEARED_SCIM_TOKEN_COLUMNS = {
  scimTokenHash: null,
  scimTokenExpiresAt: null,
  scimRequestCount: null,
  scimLastRequest: null,
} satisfies Record<string, null>;
